import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './i18n/config';
import './App.css';
import Booking from './components/Booking/Booking';
import Summary from './components/Summary/Summary';
import Terms from './components/Terms/Terms';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Booking />} />
          <Route path="/summery" element={<Summary />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;



